<template>
  <div class="container gender">
    <div class="row pt-3">
      <div class="col-12 offset-md-2 col-md-8">
        <vm-progress :percentage="4" :show-text="false" :stroke-width="18" :strokeColor="'#2bb1c4'"></vm-progress>
      </div>
    </div>
    <back-and-skip :hideSkip='true'>
    </back-and-skip>
    <div class="row pt-4 pt-lg-5">
      <div class="col-12 text-center">
        <img class="img-question" src="../assets/gender.png" alt="gender-image">
      </div>
    </div>
    <div class="row row-title">
      <div class="offset-1 col-10 offset-md-3 col-md-6">
        <label class="title">{{ $t('gender.hello') }}</label>
      </div>
    </div>
    <div class="row pt-2">
      <div class="offset-1 col-10 offset-md-3 col-md-6">
        <label class="second-title">{{ $t('gender.started') }}</label>
      </div>
    </div>
    <div class="row pt-5 pl-3">
      <div class="col-3 offset-lg-2 col-lg-2 text-center gender-option">
        <div class="row">
          <div class="offset-1 col-10 text-center">
            <input v-model="gender" type="radio" id="male" value="Male">
            <label class="inline" for="male"></label>
          </div>
        </div>
        <div class="row pt-2 pb-4">
          <div class="col-12 text-center pl-0 pr-0">
            <label class="gender-label" for="male">{{ $t('gender.male') }}</label>
          </div>
        </div>
      </div>
      <div class="offset-1 col-3 col-lg-2 gender-option">
        <div class="row">
          <div class="offset-1 col-10 text-center">
            <input v-model="gender" type="radio" id="female" value="Female">
            <label class="inline" for="female"></label>
          </div>
        </div>
        <div class="row pt-2 pb-4">
          <div class="col-12 text-center pl-0 pr-0">
            <label class="gender-label" for="female">{{ $t('gender.female') }}</label>
          </div>
        </div>
      </div>
      <div class="offset-1 col-3 col-lg-2 gender-option">
        <div class="row">
          <div class="offset-1 col-10 text-center">
            <input v-model="gender" type="radio" id="non-binary" value="Non  binary">
            <label class="inline" for="non-binary"></label>
          </div>
        </div>
        <div class="row pt-2 pb-4">
          <div class="col-12 text-center pl-0 pr-0">
            <label class="gender-label" for="non-binary">{{ $t('gender.nonBinary') }}</label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BackAndSkip from '../components/BackAndSkip.vue'

export default {
  data () {
    return {
      gender: ''
    }
  },
  components: {
    BackAndSkip
  },
  mounted () {
    this.$store.commit('SET_LAST_PAGE', 'gender')
  },
  watch: {
    gender (val) {
      if (val !== '') {
        const gender = [{
          'key': 'gender',
          'data': val
        }]

        this.$store.commit('SET_REGISTER_INFORMATION', gender)

        setTimeout(function () {
          this.$router.push({
            name: 'whoareyou'
          })
        }.bind(this), 700)
      }
    }
  }
}
</script>

<style>
@import url('https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css');

.gender .img-question {
  height: 33vh;
}

.gender .title {
  font-weight: 900;
  font-size: 2rem;
  padding-top: 4rem;
  cursor: default;
}

.gender .second-title {
  font-weight: 500;
  font-size: 1.1rem;
  cursor: default;
}

.gender .gender-option {
  background-color: white;
  border: 1px solid #b3b3b38f;
  border-radius: 10px;
}

.gender .gender-icon {
  width: 52px;
  height: 52px;
}

.gender .gender-label {
  font-weight: 800;
  font-size: 1.1rem;
}

.gender input {
  -webkit-appearance:none;
  opacity: 0;
  position: absolute;
}

.gender input, .gender label {
  display: inline-block;
  vertical-align: middle;
  margin: 5px;
  cursor: pointer;
}

.gender label {
  position: relative;
}

.gender input + label:before {
  content: '';
  background: #fff;
  border: 1px solid #ddd;
  display: inline-block;
  vertical-align: middle;
  width: 25px;
  height: 25px;
  padding: 3px;
  line-height:15px;
  margin-right: 10px;
  text-align: center;
}

.gender input + label:before {
  border-radius: 50%;
}

.gender input:checked + label:before {
  content: "\f00c";
  font-family: 'FontAwesome';
  color: white;
  background-color: #2bb1c4;
  font-size: 13px;
}

.gender input:focus + label {
  outline: 1px transparent; /* focus style */
}

@media screen and (device-aspect-ratio: 40/71) {
  .gender .img-question {
    height: 27vh;
  }

  .gender .title {
    font-size: 1.5rem;
    padding-top: 2rem;
  }

  .gender .second-title {
    font-size: .9rem;
  }

  .gender .gender-icon {
    width: 49px;
    height: 49px;
  }

  .gender .gender-label {
    font-size: 1rem;
  }

  .gender input, .gender label {
    margin: 2px;
  }
}
</style>
